import React from "react";

const HomeView = () => {
  return <>admin Home</>;
};

export default HomeView;
